import React from 'react';

export function ErrorAlert({ message }: { message: string }): React.ReactElement {
  return (
    <div className="bo-error bo-card" role="alert">
      <strong>Something went wrong.</strong>
      <p className="bo-error-msg">{message}</p>
    </div>
  );
}
